<template>
    <g>
        <path style="fill:#281F1F;" d="M41.3,43.9c-0.9,0.7-1.2,1.8-1.2,1.8c0.6-1,1.4-1.5,2.4-1.7c0,0.1,0,0.1,0,0.2c-0.1,0.7,0.2,1.3,0.7,1.6
			c-1,0-2,0-2.9-0.1c0,0,0.5,0.2,0.8,0.2c1.5,0.4,2.9,0.4,4.5,0.3c0.9-0.1,2.8-0.6,2.8-0.6s-1.3,0.1-2.9,0.2
			c0.3-0.3,0.6-0.7,0.6-1.2c0-0.2,0-0.3,0-0.4c1.4,0.3,2.5,0.8,2.5,0.8C45.9,41.8,42.4,43,41.3,43.9z"/>
        <path style="fill:#281F1F;" d="M42.7,38.9c-2.3,0.2-3.7,1.4-4.9,2.3c2.7-0.7,3.3-1.1,5.9-0.8c2.2,0.2,4.9,0.8,7.1,1.4
			c-0.4-0.8-0.5-1-0.9-1.7C47.7,39.7,43.9,38.8,42.7,38.9z"/>
        <path style="fill:#281F1F;" d="M67.2,45.6c0,0-0.2-1.1-1.2-1.8c-1.2-0.9-4.6-2-7.4,0.9c0,0,1.1-0.5,2.5-0.8c0,0.1,0,0.3,0,0.4
			c0,0.5,0.3,0.9,0.6,1.2c-1.6-0.1-2.9-0.2-2.9-0.2s1.9,0.5,2.8,0.6c1.7,0.2,3,0.2,4.5-0.3c0.2-0.1,0.8-0.2,0.8-0.2
			C66,45.5,65,45.5,64,45.5c0.5-0.4,0.8-1,0.7-1.6c0-0.1,0-0.1,0-0.2C65.8,44.1,66.7,44.6,67.2,45.6z"/>
        <path style="fill:#281F1F;" d="M69.8,41.2c-1.2-1-2.6-2.1-4.9-2.3c-1.2-0.1-5.1,0.8-7.2,1.2c-0.4,0.7-0.6,0.9-0.9,1.7
			c2.2-0.7,4.9-1.2,7.1-1.4C66.5,40.1,67.1,40.5,69.8,41.2z"/>
    </g>
</template>

<script>
    export default {
        name: 'Eye17',
    }
</script>
